/**
 * @file
 * @prettier
 */

import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

export function InitializeRTSStep2Page() {
  customValidationInit(false);
  aspControlValidationInit();
}
